import type { TableType } from "context/SmartTableContext";
import { ProjectStatus } from "models";

export const today = new Date();
export const ITEMS_PER_PAGE = 15;
export const tableType: TableType = "projects";
export const statuses: { [label: string]: string } = {
  Any: "",
  Active: ProjectStatus.ACTIVE,
  Assigned: ProjectStatus.ASSIGNED_TO_BUILDER,
  Review: ProjectStatus.QUOTE_IN_REVIEW,
  Approved: ProjectStatus.QUOTE_APPROVED,
  Ordered: ProjectStatus.ORDERED,
  Completed: ProjectStatus.COMPLETED,
};

// the pagination endpoint /projects/search accepts sortField params in the format of the value strings below
// They must be sent in this format e.g. sortField=project.name, sortField=dealer.name, etc.

export const sortFieldOptions = [
  { id: "name", value: "project.name", label: "Project Name" },
  { id: "createdAt", value: "project.createdAt", label: "Created Date" },
  { id: "status", value: "project.status", label: "Status" },
  { id: "projectOrders", value: "project.projectOrders", label: "Orders" },
  { id: "projectQuotes", value: "project.projectQuotes", label: "Quotes" },
  {
    id: "address.address1",
    value: "project.address.address1",
    label: "Address",
  },
  { id: "address.city", value: "project.address.city", label: "City" },
  { id: "address.state", value: "project.address.state", label: "State" },
  {
    id: "address.postalcode",
    value: "project.address.postalcode",
    label: "Zip",
  },
  { id: "dealerName", value: "dealer.name", label: "Dealer Name" },
  {
    id: "customer.name",
    value: "project.customer.name",
    label: "Primary Contact",
  },
];
